const defaultTeam = {
    id: '',
    dutty_manager: null,
    commercial_id_arr: [],
}

export default defaultTeam;